import {request, setAuthInHeader} from "@/api/request";
import util from "../../mixins/util";
import {logout} from "@/mixins/Auth";

import {isDev} from "@/api/config";

const state = {
    UserInfo: {},
};

const getters = {
    getUserInfo: state => state.UserInfo,
};

const mutations = {
    updateUserInfo(state, obj) {
        state.UserInfo = obj.value;
    },
    resetUserInfo(state) {
        state.UserInfo = {};
    },

};

const actions = {
    setUserInfo({commit, rootState, dispatch}, {token}) {
        setAuthInHeader(token);
        let params = {}
        request.newGet('normal/api/account', params).then((res) => {
            let result = res.data;
            if (result.code > 0 && !util.isEmpty(result.result.data)) {
                let userInfo = result.result.data;
                commit('updateUserInfo', {'value': userInfo});
            } else {
                commit('updateUserInfo', {'value': {}})
                logout();
            }
        }, (error) => {
            // 401 에러 처리: 토큰 만료 또는 유효하지 않음
            if (error.response && error.response.status === 401) {
                console.error('인증 에러 (401): 토큰이 만료되었거나 유효하지 않습니다.');
                commit('updateUserInfo', {'value': {}});
                logout();
            } else {
                console.log('error', error);
            }
        })
    },
    changeUserInfo({commit, rootState}, {data}) {
        commit('updateUserInfo', {'value': data});
    },
    initUserInfo({commit, rootState}, {data}) {
        commit('resetUserInfo');
    },

};

export default {namespaced: true, state, getters, mutations, actions}
